import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'
import React from 'react'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import StarYellow from '@src/quince-components/src/atoms/productForm/icons/starYellow.svg'
import ReviewStars from '@src/quince-components/src/atoms/reviews/reviewStars'

import {
  reviewCountCss,
  reviewCountNewDesignV2Css,
  reviewRatingCss,
  reviewRatingNewDesignV2Css,
  reviewStarIconCss,
  reviewWrapperCss,
  reviewWrapperNewDesignV2Css,
  reviewWrapperUpdatedDesignV2Css,
} from './product-info-ds.styles'

export interface ProductInfoReviewSummaryDSProps {
  avgRating?: number
  reviewCount?: number
  onReviewSummaryClick?: (e: React.MouseEvent<HTMLElement>) => void
  hideReviewCount?: boolean
  hideReviewLabel?: boolean
  productInfoReviewClassName?: string
  hideReviewSummary?: boolean
  showNewPdpDesignV2?: boolean
  updatedDesignForV2?: boolean
}

const ProductInfoReviewSummaryDS = ({
  avgRating,
  reviewCount,
  onReviewSummaryClick,
  hideReviewCount,
  hideReviewLabel,
  productInfoReviewClassName,
  hideReviewSummary,
  showNewPdpDesignV2,
  updatedDesignForV2,
}: ProductInfoReviewSummaryDSProps) => {
  const { t } = useTranslation('common')

  if (hideReviewSummary || !avgRating || Number(reviewCount) <= 0) {
    return null
  }

  return (
    <div
      className={cx(
        reviewWrapperCss,
        showNewPdpDesignV2 && reviewWrapperNewDesignV2Css,
        updatedDesignForV2 && reviewWrapperUpdatedDesignV2Css,
      )}
      onClick={onReviewSummaryClick}
    >
      <ReviewStars
        totalStars={5}
        fillStars={avgRating}
        className={cx(reviewRatingCss, showNewPdpDesignV2 && reviewRatingNewDesignV2Css)}
        classNameIcon={reviewStarIconCss}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment
        starSvg={showNewPdpDesignV2 ? (StarYellow as any) : undefined}
        showNewPdpDesignV2={showNewPdpDesignV2}
      />
      {reviewCount && !hideReviewCount && (
        <p
          data-testid={TEST_LOCATORS.FIRST_FOLD_REVIEW_COUNT}
          className={cx(reviewCountCss, showNewPdpDesignV2 && reviewCountNewDesignV2Css, productInfoReviewClassName)}
        >
          (
          <span>
            {reviewCount}
            {!hideReviewLabel && <>&nbsp;{reviewCount === 1 ? t('review') : t('reviews_v1')}</>}
          </span>
          )
        </p>
      )}
    </div>
  )
}

export default ProductInfoReviewSummaryDS
